export function Home() {
  return <div>Hello Stardeck</div>;
}
